import React, { Component } from 'react'; // eslint-disable-line
import i18n from '../../i18n';
import Logo from '../../assets/styles/img/navbar-brand.svg';
import LargeLoading from '../svg/LargeLoading';

class LoginMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            apiUP: true,
        };
    }

    componentDidMount() {
    }

    render() {
        return (
            <div id="loading-page">
                <div id="loading">{i18n.t('loading')}</div>
                <div id="loading-container_loader">
                    { this.state.apiUP
                        ? <LargeLoading /> : <p>An error has occurred. Please contact Support.</p> }
                </div>
            </div>
        );
    }
}

export default LoginMessage;
